import { render, staticRenderFns } from "./ManageOrganization.vue?vue&type=template&id=95da5900&scoped=true&"
import script from "./ManageOrganization.vue?vue&type=script&lang=js&"
export * from "./ManageOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrganization.vue?vue&type=style&index=0&id=95da5900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95da5900",
  null
  
)

export default component.exports